document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.icon-columns_swiper').forEach(function (el) {
    var prev = el.querySelector('.icon-columns_prev');
    var next = el.querySelector('.icon-columns_next');

    var swiper = new Swiper(el, {
      slidesPerView: 1,
      spaceBetween: 0,
      enabled: false,
      pagination: {
        el: el.querySelector('.icon-columns_pagination'),
        type: 'bullets',
        clickable: true,
        dynamicBullets: false
      },
      breakpoints: {
        0: {
          enabled: true,
          slidesPerView: 1,
          spaceBetween: 0
        },
        769: {
          enabled: false
        }
      }
    });

    prev.addEventListener('click', function () { swiper.slidePrev(); });
    next.addEventListener('click', function () { swiper.slideNext(); });
  });
});
